import { UserEnums } from '@project44-models/iam-gateway';

import { UIFormClient } from '../../../../../external/UIFormClient/domain/abstract/UIFormClient';
import { CheckboxFormProperty } from '../../../../../external/UIFormClient/infrastructure/ui/CheckboxFormProperty';
import { DropdownFormProperty } from '../../../../../external/UIFormClient/infrastructure/ui/DropdownFormProperty';
import { InputFieldFormProperty } from '../../../../../external/UIFormClient/infrastructure/ui/InputFieldFormProperty';
import { IUserFormCreator } from '../../../../User/domain/interfaces';

export interface IUserCreationFormTemplate {
  properties: UIFormClient<IUserFormCreator>['properties'];
}

export abstract class UserCreationFormTemplate {
  public abstract availableUserTypes: Array<UserEnums.UserTypeEnum> | undefined;

  public compose(): IUserCreationFormTemplate {
    const emptyInputField = {
      initialValue: '',
      isDisplayable: true,
      isEditable: true,
    };

    return {
      properties: {
        username: InputFieldFormProperty.create(
          { label: 'Email' },
          emptyInputField,
        ),
        givenName: InputFieldFormProperty.create(
          { label: 'Given name' },
          emptyInputField,
        ),
        familyName: InputFieldFormProperty.create(
          { label: 'Family name' },
          emptyInputField,
        ),
        password: InputFieldFormProperty.create(
          { label: 'Password' },
          emptyInputField,
        ),
        phoneNumber: InputFieldFormProperty.create(
          { label: 'Phone number' },
          emptyInputField,
        ),
        userType:
          this.availableUserTypes === undefined
            ? CheckboxFormProperty.compose(
                {
                  initialValue: 'false',
                  isDisplayable: true,
                  isEditable: true,
                  label: 'dfddf',
                  helperText:
                    'Contact persons are visible for other companies when requesting data sharing. Since contact persons can receive invitations, they must be Administrators to accept/reject invitations.',
                },
                { children: 'Contact person' },
              )
            : DropdownFormProperty.compose(
                [
                  {
                    displayValue: UserEnums.UserTypeEnum.USER,
                    value: UserEnums.UserTypeEnum.USER,
                  },
                ],
                {
                  initialValue: UserEnums.UserTypeEnum.USER,
                  isDisplayable: true,
                  isEditable: true,
                },
              ),
        isAdmin: CheckboxFormProperty.compose(
          {
            initialValue: 'false',
            isDisplayable: true,
            isEditable: true,
          },
          { children: 'Administrator' },
        ),
      },
    };
  }
}
